import * as ActionType from '../../constants/actionType';

const initialState = {
  show: false,
  type: undefined,
  param: {},
};

export default function modalSetTrayIDStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SHOW_MODAL_SET_TRAY_ID:
      return action.param
        ? {...state, show: true, type: action.data, param: action.param}
        : {...state, show: true, type: action.data};
    case ActionType.HIDE_MODAL_SET_TRAY_ID:
      return {...state, show: false};
    case ActionType.RESET_MODAL_SET_TRAY_ID:
      return initialState;
    default:
      return state;
  }
}
